import { BaseLayoutFactory } from "../global/base-layout-factory";
import { BiddingProvider } from "./context/bidding-context";
import { BiddingComponent } from "./bidding-component";

export function BiddingFactory() {
    return (
        <BaseLayoutFactory>
            <BiddingProvider>
                <BiddingComponent />
            </BiddingProvider>
        </BaseLayoutFactory>
    );
}